import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Button, Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/LanguageContext';
import { trackUmamiEvent } from '../../lib/analytics/umami';
import { handleAuthRedirectClick } from '../../lib/navigation/externalBrowser';

const FAQ_KEYS = [
  'faq.q1', 'faq.q2', 'faq.q3', 'faq.q4', 'faq.q5', 'faq.q6',
  'faq.q7', 'faq.q8', 'faq.q9', 'faq.q10', 'faq.q11', 'faq.q12',
];

export function buildFaqJsonLd(t) {
  return {
    '@type': 'FAQPage',
    mainEntity: FAQ_KEYS.map((key) => ({
      '@type': 'Question',
      name: t(key),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`${key}.answer`),
      },
    })),
  };
}

export default function Faq() {
  const { t } = useTranslation();

  return (
    <Flex
      as="section"
      aria-label={t('faq.aria')}
      flexDirection="column"
      width="100%"
      maxW="800px"
      gap="24px"
      backgroundColor="background.grey"
      border="1px solid"
      borderColor="divider.grey"
      borderRadius="20px"
      px={['24px', '40px', '50px']}
      py={['30px', '40px', '50px']}
    >
      <Text
        as="h2"
        fontSize={['25px', '30px']}
        fontWeight="500"
        color="text.dark.grey"
        textAlign="center"
      >
        {t('faq.title')}
      </Text>
      <Accordion allowToggle>
        {FAQ_KEYS.map((key, index) => (
          <AccordionItem
            key={key}
            border="1px solid"
            borderColor="divider.grey"
            borderRadius="12px"
            backgroundColor="white"
            overflow="hidden"
            mb={index < FAQ_KEYS.length - 1 ? '12px' : 0}
          >
            <AccordionButton
              py={4}
              px={4}
              _hover={{ bg: 'background.component.grey' }}
              _expanded={{ bg: 'background.component.grey' }}
            >
              <Text
                as="h3"
                flex="1"
                textAlign="left"
                fontSize="16px"
                fontWeight="500"
                color="text.dark.grey"
              >
                {t(key)}
              </Text>
              <AccordionIcon color="text.medium.grey" />
            </AccordionButton>
            <AccordionPanel
              px={4}
              pb={4}
              pt={3}
              color="text.medium.grey"
              fontSize="15px"
              lineHeight="1.6"
            >
              <Flex flexDirection="column" alignItems="flex-start" gap={4}>
                <Text>{t(`${key}.answer`)}</Text>
                {key === 'faq.q12' && (
                  <Link
                    to={process.env.REACT_APP_BIBLIONA_URL}
                    target="_blank"
                    onClick={(event) =>
                      handleAuthRedirectClick(event, process.env.REACT_APP_BIBLIONA_URL, () =>
                        trackUmamiEvent('cta_click', { location: 'faq', cta: 'sign_in' })
                      )
                    }
                  >
                    <Button variant="coralFill">
                      {t('nav.signIn')}
                    </Button>
                  </Link>
                )}
              </Flex>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Flex>
  );
}
